export default {
  getLog: state =>  {
    return state.log
  }
}